<template>
  <v-container fluid class="grey lighten-5 pa-0">
    <v-container class="py-12">

      <v-row v-if="TipoUsuario !== 'Administrador'" class="mb-8">
        <v-col cols="12">
          <v-card class="mx-auto py-4 px-4" flat color="transparent" rounded="lg">
            <v-row justify="center" align="center">
              <v-col cols="12">
                <v-img
                  height="220px"
                  contain
                  src="../assets/banner_CCO.png"
                ></v-img>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>

      <v-row justify="center" class="mb-8">
        <v-col cols="12" class="text-center">
          <h2 class="text-h4 font-weight-bold primary--text">Bienvenido a la Bolsa de Empleo</h2>
          <p class="subtitle-1 grey--text text--darken-2 mt-2">Explora las oportunidades que tenemos para ti</p>
        </v-col>
      </v-row>

      <v-row justify="center" align="stretch" spacing="6">

        <v-col cols="12" md="12" lg="10" v-if="TipoUsuario === 'Administrador'">
          <FormAdministrator />
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="3" v-if="TipoUsuario == 'Persona' || TipoUsuario == ''">
          <v-card class="mx-auto d-flex flex-column service-card pa-4" height="100%" elevation="2" rounded="lg" hover>
            <div class="img-container mb-3">
              <v-img
                height="220px"
                src="../assets/personas.jpg"
                class="align-end zoom-img rounded-lg"
                cover
              >
              </v-img>
            </div>
            <v-card-title class="justify-center font-weight-bold pt-2 title-text text-truncate">Mi hoja de vida</v-card-title>
            <v-card-text class="text-center subtitle-1 grey--text text--darken-1">
              Ingresa o actualiza tu hoja de vida y encuentra las mejores ofertas.
            </v-card-text>
            <v-spacer></v-spacer>
            <v-card-actions class="justify-center">
              <v-btn :to="{name:'hojadevida'}" color="orange darken-2" dark rounded block depressed class="font-weight-bold button-hover">
                Ingresa tu hoja de vida
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="3" v-if="TipoUsuario == 'Empresa' || TipoUsuario == ''">
          <v-card class="mx-auto d-flex flex-column service-card pa-4" height="100%" elevation="2" rounded="lg" hover>
            <div class="img-container mb-3">
              <v-img
                height="220px"
                src="../assets/Reclutadores.jpg"
                class="align-end zoom-img rounded-lg"
                cover
              >
              </v-img>
            </div>
            <v-card-title class="justify-center font-weight-bold pt-2 title-text text-truncate">Reclutadores</v-card-title>
            <v-card-text class="text-center subtitle-1 grey--text text--darken-1">
              Regístrese como empresa y comparta ofertas con la comunidad.
            </v-card-text>
            <v-spacer></v-spacer>
            <v-card-actions class="justify-center">
              <v-btn :to="{name:'hojadevidareclutador'}" color="orange darken-2" dark rounded block depressed class="font-weight-bold button-hover">
                Registre su empresa
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="3" v-if="TipoUsuario == 'Persona' || TipoUsuario == ''">
          <v-card class="mx-auto d-flex flex-column service-card pa-4" height="100%" elevation="2" rounded="lg" hover>
            <div class="img-container mb-3">
              <v-img
                height="220px"
                src="../assets/Ofertas_banner.jpg"
                class="align-end zoom-img rounded-lg"
                cover
              >
              </v-img>
            </div>
            <v-card-title class="justify-center font-weight-bold pt-2 title-text text-truncate">Vacantes Disponibles</v-card-title>
            <v-card-text class="text-center subtitle-1 grey--text text--darken-1">
              Consulta las vacantes laborales y educativas publicadas.
            </v-card-text>
            <v-spacer></v-spacer>
            <v-card-actions class="justify-center">
              <v-btn :to="{name:'filtroOfertas'}" color="orange darken-2" dark rounded block depressed class="font-weight-bold button-hover">
                Ver Ofertas
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="3" v-if="TipoUsuario == 'Empresa' || TipoUsuario == ''">
          <v-card class="mx-auto d-flex flex-column service-card pa-4" height="100%" elevation="2" rounded="lg" hover>
            <div class="img-container mb-3">
              <v-img
                height="220px"
                src="../assets/Ofertas.jpg"
                class="align-end zoom-img rounded-lg"
                cover
              >
              </v-img>
            </div>
            <v-card-title class="justify-center font-weight-bold pt-2 title-text text-truncate">Ofertas Laborales</v-card-title>
            <v-card-text class="text-center subtitle-1 grey--text text--darken-1">
              Ingresa y publica tus ofertas laborales o educativas.
            </v-card-text>
            <v-spacer></v-spacer>
            <v-card-actions class="justify-center">
              <v-btn :to="{name:'ofertaslaborales'}" color="orange darken-2" dark rounded block depressed class="font-weight-bold button-hover">
                Publicar oferta
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="3" v-if="TipoUsuario !== 'Administrador'">
          <v-card class="mx-auto d-flex flex-column service-card pa-4" height="100%" elevation="2" rounded="lg" hover>
            <div class="img-container mb-3">
              <v-img
                height="220px"
                src="../assets/News.jpg"
                class="align-end zoom-img rounded-lg"
                cover
              >
              </v-img>
            </div>
            <v-card-title class="justify-center font-weight-bold pt-2 title-text text-truncate">Noticias</v-card-title>
            <v-card-text class="text-center subtitle-1 grey--text text--darken-1">
              Mantente informado acerca de las principales noticias del colegio.
            </v-card-text>
            <v-spacer></v-spacer>
            <v-card-actions class="justify-center">
              <v-btn href="https://colegiodeodontologos.org/noticias/" target="_blank" color="orange darken-2" dark rounded block depressed class="font-weight-bold button-hover">
                Ver noticias
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>

      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import store from "../store/index.js";
import {mapMutations, mapState} from 'vuex';
import auth from "@/auth";
import readXlsFile from "read-excel-file";
import Vue from "vue";
import Vuelidate from "vuelidate";
import {required} from 'vuelidate/lib/validators';
import FormAdministrator from '../components/FormAdministrator.vue'

Vue.use(Vuelidate);

  export default {
    name: 'Home',
  
    data: () => ({
      show: false,
      model: 0,
      Admin_CargaArchivo: 1,
      Admin_Verificacion: 0,
      Admin_ConsultaCandidato: 0,
      items:[],
      filesRethus: [],
       cabecera: [
        {text:"CONSECUTIVO", value:'Consecutivo'},
        {text:"COLUMNA ERROR", value:'Columna'},
        {text:"DESCRIPCION ERROR", value:'Descripcion'},
        {text:"VALOR ERRADO", value:'Valor'},
        {text:"EJEMPLO ", value:'Ejemplo'},
      ],   
      enviado:false,
      error: "", 
      Errores:[]
  
  }),

    validations:{
      filesRethus:{required}
    },

    beforeMount() {        
      const Name = auth.getUserLogged();

       if(this.userLogged === undefined){
        store.commit('AsignarValorLogin', { ValorLogin: 0, user:'',tipousuario :'' });
      }else{
        store.commit('AsignarValorLogin', { ValorLogin: 1, user:Name.username,tipousuario :Name.tipousuario });
      }   
    },

    components: {
      FormAdministrator
    },

    methods:
    {

      
      UploadFile(){
        alert("mensaje")
      },


      UploadFileRethus(){
        this.enviado = true;
        const Er_TipoId = /^[a-zA-Z]{2}$/;
        const Er_NroId = /^[0-9]{1,15}$/;
        const Er_PNombrePapellido = /^[a-zA-ZáéíóúÁÉÍÓ ]{1,25}$/;
        const Er_SNombreSapellido = /^[a-zA-ZáéíóúÁÉÍÓÚ ]{0,25}$/;

        
       if(this.filesRethus !== "")
          {            
             readXlsFile(this.filesRethus).then((rows) =>{
            this.items = rows.filter((row, indice) => indice > 0);

            //Procesar el archivo
            for(let i=0; i< this.items.length; i++ )
            {
                if(Er_TipoId.exec(this.items[i][1]) === null)
                {
                    var Consecutivo = this.items[i][0];
                    var Columna = "Tipo Identificación";
                    var Descripcion = "Se permiten exactamente 2 letras, no números, no espacios, no caracteres especiales";
                    var Valor = this.items[i][1]
                    var Ejemplo = "CC , CE, PA"
                    this.Errores.push({Consecutivo,Columna,Descripcion,Valor,Ejemplo})
                    this.error = this.error + 1;
                }

                if(Er_NroId.exec(this.items[i][2]) === null)
                {
                    var Consecutivo = this.items[i][0];
                    var Columna = "Número Identificación";
                    var Descripcion = "Tiene letras, caracteres ilegales o supera 15 caracteres";
                    var Valor = this.items[i][2]
                    var Ejemplo = "99123456"
                    this.Errores.push({Consecutivo,Columna,Descripcion,Valor,Ejemplo})
                    this.error = this.error + 1;
                }

                if(Er_PNombrePapellido.exec(this.items[i][3]) === null)
                {
                    var Consecutivo = this.items[i][0];
                    var Columna = "Primer Apellido";
                    var Descripcion = "Tiene números, caracteres ilegales o supera 25 caracteres";
                    var Valor = this.items[i][3]
                    var Ejemplo = "Pérez"
                    this.Errores.push({Consecutivo,Columna,Descripcion,Valor,Ejemplo})
                    this.error = this.error + 1;
                } 
                
                if(Er_SNombreSapellido.exec(this.items[i][4]) === null)
                {
                    var Consecutivo = this.items[i][0];
                    var Columna = "Segundo Apellido";
                    var Descripcion = "Tiene números, caracteres ilegales o supera 25 caracteres";
                    var Valor = this.items[i][4]
                    var Ejemplo = "Pérez"
                    this.Errores.push({Consecutivo,Columna,Descripcion,Valor,Ejemplo})
                    this.error = this.error + 1;
                }   
                
                if(Er_PNombrePapellido.exec(this.items[i][5]) === null)
                {
                    var Consecutivo = this.items[i][0];
                    var Columna = "Primer Apellido";
                    var Descripcion = "Tiene números, caracteres ilegales o supera 25 caracteres";
                    var Valor = this.items[i][5]
                    var Ejemplo = "Castillo"
                    this.Errores.push({Consecutivo,Columna,Descripcion,Valor,Ejemplo})
                    this.error = this.error + 1;
                } 
                
                if(Er_SNombreSapellido.exec(this.items[i][6]) === null)
                {
                    var Consecutivo = this.items[i][0];
                    var Columna = "Segundo Apellido";
                    var Descripcion = "Tiene números, caracteres ilegales o supera 25 caracteres";
                    var Valor = this.items[i][6]
                    var Ejemplo = "GoméZ"
                    this.Errores.push({Consecutivo,Columna,Descripcion,Valor,Ejemplo})
                    this.error = this.error + 1;
                }                  


                if(this.error.length === 0){
                  this.error = 0;
                }
               
            } 
            
            }) 


              

          }
      },

      CleanFileRethus(){
       this.filesRethus = "";
       this.items = [];
       this.error= ""
      }



    },

    computed: 
      {
          userLogged() {
          return auth.getUserLogged();
          },

      ...mapState(['VarLogin','TipoUsuario'])
      }
  }
</script>

<style scoped>
/* 1. Comportamiento de la tarjeta al pasar el mouse */
.service-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.service-card:hover {
  transform: translateY(-5px); /* Levanta la tarjeta */
  box-shadow: 0 10px 20px rgba(0,0,0,0.12) !important; /* Sombra más profunda */
}

/* 2. Contenedor de la imagen (El Marco) */
.img-container {
  overflow: hidden;       /* IMPORTANTE: Recorta la imagen si se sale al hacer zoom */
  border-radius: 8px;     /* Redondea las esquinas de la imagen */
}

/* 3. La imagen en sí */
.zoom-img {
  transition: transform 0.5s ease; /* Transición suave del zoom */
}

/* 4. El Efecto: Cuando haces hover en la CARD, la IMAGEN crece */
.service-card:hover .zoom-img {
  transform: scale(1.1); /* Agranda la imagen un 10% */
}

/* Ajustes menores de texto */
.v-card__title {
  word-break: break-word;
  line-height: 1.2;
}
</style>